import { render, staticRenderFns } from "./CreateSpectator.vue?vue&type=template&id=196699ee"
import script from "./CreateSpectator.vue?vue&type=script&lang=js"
export * from "./CreateSpectator.vue?vue&type=script&lang=js"
import style0 from "./CreateSpectator.vue?vue&type=style&index=0&id=196699ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports